import { api } from '../../AxiosConfig';

export class OfertasHorarioService {
  quota(date: Date | string) {
    return api.get('/ofertas-horario/quota', { params: { date } });
  }

  findAll(date?: Date | string, attendantId?: string) {
    const params: any = {};
    if (date) params.date = date;
    if (attendantId) params.attendantId = attendantId;
    return api.get('/ofertas-horario/findAll', { params });
  }

  day(date: Date | string, attendantId?: string) {
    return api.get('/ofertas-horario/day', { params: { date, attendantId } });
  }

  details(offerId: string) {
    return api.get(`/ofertas-horario/${offerId}`);
  }

  previewServices(payload: {
    attendantId: string;
    date: Date | string;
    startMinutes: number;
    endMinutes: number;
    discountPercent?: number;
  }) {
    return api.post('/ofertas-horario/preview-services', payload);
  }

  create(payload: {
    attendantId: string;
    date: Date | string;
    startMinutes: number;
    endMinutes: number;
    discountPercent?: number;
    clientIds: string[];
    templateName?: string;
  }) {
    return api.post('/ofertas-horario/create', payload);
  }
}
